module.exports = "<app-globalnav></app-globalnav><div class=\"container-fluid domain-view\"><div class=\"row\"><router-outlet></router-outlet></div></div><app-login></app-login>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.pug
// module id = 1079
// module chunks = 1